export default __webpack_public_path__ + "static/media/MU.c3d610eb.ico";